<template>
	<div>
		<SimpleModal
			@close="close"
			:tabOrder="[
				{ css: '.task-card-check', clickOnEnter: true },
				{ css: '.upload-message-input' },
				{ css: '.btn-cancel-med', clickOnEnter: true },
				{ css: '.btn-submit-med', clickOnEnter: true },
			]"
		>
			<div class="discuss-task-modal">
				<div v-if="!showSpinner" class="discuss-task-wrapper">
					<div class="upload-title">
						{{ $t('tasks_discuss_title') }}
					</div>
					<div class="task-card-wide">
						<div class="task-card-top">
							<img
								class="task-card-check"
								src="/images/common/task-checkbox.png"
							/>
							<span id="task-card-span" data-private>{{ taskdata.title }}</span>
							<img
								id="task-card-arrow"
								src="/images/common/task-list-arrow.png"
							/>
						</div>
						<div class="task-card-bottom task-card-bottom-corners">
							<div>
								<img src="/images/common/task-card-calendar.png" />
								<span>{{
									$t('tasks_due_date', [dueDateDisplay(taskdata.due)])
								}}</span>
							</div>
						</div>
					</div>

					<textarea
						v-focus
						@keydown.enter.prevent="enterPressed"
						placeholder="Add a message (optional)"
						class="upload-message-input"
						rows="2"
						v-model="message"
						data-private="lipsum"
					>
					</textarea>
					<div class="discuss-task-buttons">
						<button class="btn-cancel-med mar-r-8" @click="close">
							{{ $t('common_button_cancel') }}
						</button>
						<button
							class="btn-submit-med mar-l-8"
							@click="sendMessage"
							:disabled="!message"
						>
							{{ $t('common_button_ok') }}
						</button>
					</div>
				</div>
				<div id="centerDiv">
					<div v-if="showSpinner" class="center-loader">
						<span>
							<img src="/images/pronto/3-dot-loader.gif" />
							<p></p>
						</span>
					</div>
				</div>
			</div>
		</SimpleModal>
	</div>
</template>

<script>
import store, { getDMChats, getMyUserId } from '../store'
import { post } from '../helpers/api'
import moment from 'moment'
import { dayOfWeek } from '@/helpers/utils'
import { createDM } from '@/api/chat'
import { SimpleModal } from './common'

export default {
	components: { SimpleModal },
	props: ['taskdata'],
	data() {
		return {
			store,
			message: '',
			showSpinner: false,
		}
	},
	emits: ['closeDiscuss', 'closeAll', 'sendFailed'],
	methods: {
		dueDateDisplay(date) {
			// This date is a "floating date" which means it should be
			// interpretted as being in the user's local timezone
			let DOW = this.dayOfWeek(date)

			if (DOW === 'TODAY' || DOW === 'TOMORROW' || DOW === 'YESTERDAY') {
				return this.$t(`common_${DOW.toLowerCase()}`)
			} else {
				return moment(date).local().format('LL')
			}
		},

		dayOfWeek(date) {
			// This date is a "floating date" which means it should be
			// interpretted as being in the user's local timezone
			return dayOfWeek(date)
		},

		close() {
			this.$emit('closeDiscuss')
		},

		uuid() {
			return window.crypto.randomUUID()
		},

		async sendMessage() {
			this.showSpinner = true
			if (this.message) {
				if (this.taskdata.assigneeuser_id) {
					let group = getDMChats().find(
						(c) => c.dmpartner_id == this.taskdata.assigneeuser_id
					)

					//if we don't have an existing DM with the assignee, create one
					if (!group) {
						const ids = [getMyUserId(), this.taskdata.assigneeuser_id]
						group = await createDM(ids)
					}
					var chat_id = group.id
				} else {
					var chat_id = this.taskdata.bubble_id
				}

				let post_data = {
					bubble_id: chat_id,
					message: this.message,
					task_id: this.taskdata.id,
					uuid: this.uuid(),
				}

				post('/api/v1/message.create', post_data)
					.then(({ data }) => {
						this.showSpinner = false
						this.$emit('closeAll')
						this.close()
						this.$router.push('/chat/' + chat_id)
					})
					.catch((error) => {
						m.sendState = 'failed'
						this.$emit('sendFailed')
						this.showSpinner = false
						if (error.response == undefined) {
							return
						}

						switch (error.response.data.error) {
							default:
								console.error(
									'Unhandled error in DiscussTask.vue:sendMessage - ' +
										error.response.data.error
								)
								break
						}
					})
			} else {
				this.$emit('closeAll')
				this.close()
				this.$router.push('/chat/' + chat_id)
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.discuss-task-wrapper {
	padding: 0 40px 40px 40px;
}
.upload-message-input {
	position: relative;
	outline: none;
}
.discuss-task-buttons {
	text-align: right;
	margin-top: 16px;
}
.task-card-top,
.task-card-bottom {
	text-align: left;
}

.center-loader {
	display: inline-block;
	margin: 120px;
}

:disabled {
	cursor: default;
	background-color: #cfd7da;
	color: #4f5053;
}
</style>
